export default __webpack_public_path__ + "static/media/search.b0e8e10a.svg";